import toast from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import getCSRFToken from '../../../utils/CSRFToken';
import { STARTING_STYLES } from '../lib';
import { useBrandStore } from '../context';

export default function DynamicBrandLanding(props) {
  const { endpoints } = props;
  const { createOrUpdateUrl } = endpoints;

  const isLoading = useBrandStore((state) => state.isLoading);
  const setIsLoading = useBrandStore((state) => state.setIsLoading);

  const createOrUpdateMutation = useMutation({
    mutationFn: async () => {
      const response = await fetch(`${createOrUpdateUrl}.json`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          ...getCSRFToken(),
        },
        body: JSON.stringify({
          dynamic_brand: {
            site_name: 'My Recruitment Site',
            site_slogan: 'Powered by SourceFlow',
            styles: STARTING_STYLES,
          },
        }),
      });

      if (!response.ok) {
        const errors = await response.json();
        const errorMessage = JSON.stringify(errors?.error) || 'An error occurred while creating or updating the dynamic brand';
        throw new Error(errorMessage);
      }
    },
    onMutate: () => setIsLoading(true),
    onError: (error) => {
      toast.error(`Error: ${error.message || 'An error occurred while saving changes'}`);
    },
    onSuccess: () => {
      toast.success('Brand kit successfully initialised! Redirecting you in 3 seconds...');
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    },
    onSettled: () => setIsLoading(false),
  });

  return (
    <div className="db-landing">
      <div className="top-side">
        {isLoading ? (
          <div className="left-side">
            <div className="d-flex gap-3">
              <div className="spinner-grow" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="spinner-grow" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="spinner-grow" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="left-side">
            <h1>
              Launch your recruitment website faster. <br /> Manage it easier.
            </h1>
            <p className="m-0">Take full control of your your site's branding, colours and styles. No hassle!</p>
          </div>
        )}
      </div>
      <div className="bottom-side">
        <button className="btn btn-primary" onClick={() => createOrUpdateMutation.mutate()}>
          Begin now!
        </button>
      </div>
    </div>
  );
}
